/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AllergenPropertyKind =
  | 'CRUSTACEAN_SHELLFISH'
  | 'EGGS'
  | 'FISH'
  | 'MEAT'
  | 'MILK'
  | 'PEANUTS'
  | 'SESAME'
  | 'SOYBEANS'
  | 'TREE_NUTS'
  | 'WHEAT';

export type DietaryPropertyKind = 'DAIRY' | 'FISH' | 'GLUTEN' | 'MEAT' | 'NUTS' | 'SOY';

export type DressingMode = 'MIXED' | 'NOT_DRESSABLE' | 'ON_THE_SIDE' | 'REMOVED';

export type DressingWeight = 'HEAVY' | 'LIGHT' | 'MEDIUM';

export type FavoritedLineItemsInput = {
  readonly page: number;
};

export type FavoritesQueryVariables = Exact<{
  input: Types.FavoritedLineItemsInput;
}>;

export type FavoritesQuery = {
  readonly favoritedLineItems: ReadonlyArray<{
    readonly __typename: 'LineItem';
    readonly id: string;
    readonly slug: string;
    readonly customName: string | null;
    readonly quantity: number;
    readonly cost: number;
    readonly perItemCost: number;
    readonly favorited: boolean;
    readonly dressingMode: Types.DressingMode;
    readonly product: {
      readonly __typename: 'Product';
      readonly id: string;
      readonly name: string;
      readonly calories: number;
      readonly cost: number;
      readonly isCustom: boolean;
      readonly enableDressingDetails: boolean;
      readonly description: string;
      readonly label: {
        readonly __typename: 'ProductLabel';
        readonly id: string;
        readonly name: string;
      } | null;
      readonly asset: { readonly url: string };
      readonly restaurant: { readonly __typename: 'Restaurant'; readonly id: string };
      readonly allergenProperties: ReadonlyArray<{
        readonly __typename: 'AllergenProperty';
        readonly id: string;
        readonly name: Types.AllergenPropertyKind;
      }>;
      readonly dietaryProperties: ReadonlyArray<{
        readonly __typename: 'DietaryProperty';
        readonly id: string;
        readonly name: Types.DietaryPropertyKind;
      }>;
    };
    readonly ingredients: ReadonlyArray<{
      readonly __typename: 'Ingredient';
      readonly id: string;
      readonly name: string;
    }>;
    readonly addedIngredients: ReadonlyArray<{
      readonly __typename: 'Ingredient';
      readonly id: string;
      readonly name: string;
    }>;
    readonly removedIngredients: ReadonlyArray<{
      readonly __typename: 'Ingredient';
      readonly id: string;
      readonly name: string;
    }>;
    readonly mixedDressingDetails: ReadonlyArray<{
      readonly ingredientId: string;
      readonly weight: Types.DressingWeight;
    }>;
  }>;
};

export const FavoritesDocument = gql`
  query favorites($input: FavoritedLineItemsInput!) {
    favoritedLineItems(input: $input) {
      id
      __typename
      slug
      customName
      quantity
      cost
      perItemCost
      favorited
      product {
        id
        __typename
        name
        calories
        cost
        isCustom
        enableDressingDetails
        label {
          id
          __typename
          name
        }
        description
        asset {
          url
        }
        restaurant {
          id
          __typename
        }
        allergenProperties {
          id
          __typename
          name
        }
        dietaryProperties {
          id
          __typename
          name
        }
      }
      ingredients {
        id
        __typename
        name
      }
      addedIngredients {
        id
        __typename
        name
      }
      removedIngredients {
        id
        __typename
        name
      }
      mixedDressingDetails {
        ingredientId
        weight
      }
      dressingMode
    }
  }
`;

export function useFavoritesQuery(
  options: Omit<Urql.UseQueryArgs<FavoritesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<FavoritesQuery, FavoritesQueryVariables>({
    query: FavoritesDocument,
    ...options,
  });
}
